export class Sprite {
	image: HTMLImageElement | HTMLCanvasElement | null = null;
	assetName: string = "";
	width: number = 1;
	height: number = 1;
	rotation: number = 0;
	flipH: boolean = false;
	flipV: boolean = false;
	offsetX: number = 0;
	offsetY: number = 0;
	character: string | null = null;
	foreground: string | null = null;
	background: string | null = null;
}
